"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToDocsToken = exports.logout = exports.getCurrentToken = exports.getCurrentTokenWithoutRedirect = exports.getAuthenticationUrl = exports.clearToken = void 0;
var cache_1 = require("./cache");
var fetchToken_1 = require("./fetchToken");
var config_1 = require("../helpers/config");
var latestTokenPromise = null;
var clearToken = function () {
    (0, cache_1.clearCachedCurrentToken)();
};
exports.clearToken = clearToken;
var getAuthenticationUrl = function (res) {
    return res.authenticationUrl;
};
exports.getAuthenticationUrl = getAuthenticationUrl;
// IMPORTANT! change the version here anytime `innerGetCurrentTokenWithoutRedirect` is being updated!
var getTokenFunctionVersion = 1;
var innerGetCurrentTokenWithoutRedirect = function () {
    if (latestTokenPromise) {
        return latestTokenPromise;
    }
    var currentToken = (0, cache_1.getCachedCurrentToken)();
    if (!currentToken ||
        new Date(currentToken.expiresAt).getTime() - Date.now() <= 300 * 1000) {
        latestTokenPromise = (0, fetchToken_1.fetchToken)()
            .then(function (token) {
            latestTokenPromise = null;
            (0, cache_1.setCachedCurrentToken)(token);
            return token;
        })
            .catch(function (e) {
            latestTokenPromise = null;
            if ((0, exports.getAuthenticationUrl)(e)) {
                (0, exports.clearToken)();
            }
            throw e;
        });
        return latestTokenPromise;
    }
    return Promise.resolve(currentToken);
};
var globalGetTokenFunctionKeyName = '__ACSGetAccessToken';
var globalGetTokenFunctionVersionKeyName = '__ACSGetAccessTokenVersion';
var getCurrentTokenWithoutRedirect = function () {
    var fn = window[globalGetTokenFunctionKeyName];
    var fnVersion = window[globalGetTokenFunctionVersionKeyName];
    if (!fn || !fnVersion || fnVersion < getTokenFunctionVersion) {
        fn = window[globalGetTokenFunctionKeyName] =
            innerGetCurrentTokenWithoutRedirect;
        window[globalGetTokenFunctionVersionKeyName] = getTokenFunctionVersion;
    }
    return fn();
};
exports.getCurrentTokenWithoutRedirect = getCurrentTokenWithoutRedirect;
var getCurrentToken = function () {
    return (0, exports.getCurrentTokenWithoutRedirect)().catch(function (e) {
        var authenticationUrl = (0, exports.getAuthenticationUrl)(e);
        if (authenticationUrl) {
            window.location.assign(authenticationUrl);
        }
        throw e;
    });
};
exports.getCurrentToken = getCurrentToken;
var logout = function (redirectUrl) {
    if (redirectUrl === void 0) { redirectUrl = window.location.href; }
    (0, exports.clearToken)();
    window.location.assign("".concat((0, config_1.getLoginUrl)(), "/api/v1/authentication/logout?redirectUrl=").concat(redirectUrl));
};
exports.logout = logout;
var convertToDocsToken = function (_a) {
    var accessToken = _a.accessToken, expiresAt = _a.expiresAt;
    return ({
        token: accessToken,
        token_expiration: Math.round((new Date(expiresAt).getTime() - Date.now()) / 1000),
    });
};
exports.convertToDocsToken = convertToDocsToken;
